import { Button } from '@ps-design-system/components/Button';
import React from 'react';
import { FormattedMessage } from 'react-intl';

export const AddCateringCard = ({ router, bookingId }) => {
  const handleCtaClick = () => {
    router.push(`/inbox/${bookingId}/catering`);
  };

  return (
    <div
      style={{
        padding: '40px',
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '16px',
        backgroundImage:
          'url(https://img.peerspace.com/image/upload/v1725383524/74wa3x7e22tj2iq0nzqt.jpg)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        borderRadius: '4px'
      }}
    >
      <h3 className="no-margin tw-headline-4-b text-center text-white">
        <FormattedMessage
          id="add_catering_card.add_catering"
          defaultMessage="Add catering for your event"
        />
      </h3>
      <Button appearance="purple" onClick={handleCtaClick}>
        <FormattedMessage
          id="add_catering_card.explore_options"
          defaultMessage="Explore options"
        />
      </Button>
    </div>
  );
};
